/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_BenefitsInputs */

const et_nav_benefits = /** @type {(inputs: Nav_BenefitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miks?`)
};

const en_nav_benefits = /** @type {(inputs: Nav_BenefitsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benefits`)
};

/**
* | output |
* | --- |
* | "Benefits" |
*
* @param {Nav_BenefitsInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_benefits = /** @type {((inputs?: Nav_BenefitsInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_BenefitsInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_nav_benefits(inputs)
	return en_nav_benefits(inputs)
});